import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, CalendarClock } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString() : "Not sent yet");

export const AdminSummaryCard = () => {
  const [info, setInfo] = useState(null);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    api.get("/admin/monitoring/admin-summary").then((r) => setInfo(r.data)).catch(() => setInfo(null));
  }, []);

  const send = async () => {
    setSending(true);
    try {
      const { data } = await api.post("/admin/monitoring/admin-summary/test");
      toast.success(`Test summary sent to ${data.to} — covers the last 24 hours.`);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Couldn't send the test summary.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="mt-8 rounded-2xl border border-[#1E3F33]/10 bg-white p-5" data-testid="admin-summary-card">
      <h2 className="font-heading text-xl text-[#1E3F33] font-semibold flex items-center gap-2 mb-1">
        <CalendarClock className="w-5 h-5 text-[#2D6A4F]" /> Daily activity summary
      </h2>
      <p className="text-xs text-[#8A9A86] mb-4">New sign-ups, service requests and reviews, emailed every day at 8:00 AM ET.</p>
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <dl className="text-sm text-[#1E3F33] space-y-1">
          <div><dt className="inline text-[#5C6B64]">Sends to: </dt><dd className="inline font-medium break-all" data-testid="admin-summary-to">{info?.to || "…"}</dd></div>
          <div><dt className="inline text-[#5C6B64]">Last daily summary: </dt><dd className="inline" data-testid="admin-summary-last">{info ? fmt(info.last_sent_at) : "…"}</dd></div>
        </dl>
        <button onClick={send} disabled={sending || !info} data-testid="admin-summary-test-send"
          className="text-sm py-2.5 px-4 inline-flex items-center gap-2 rounded-full bg-[#2D6A4F] text-white hover:bg-[#245741] transition-colors disabled:opacity-40">
          <Mail className="w-4 h-4" /> {sending ? "Sending…" : "Send test summary"}
        </button>
      </div>
      <p className="text-xs text-[#8A9A86] mt-3">The test covers the last 24 hours and doesn't change what the next 8 AM email includes.</p>
    </div>
  );
};
